import { render, staticRenderFns } from "./CardAdditionalInformationIcon.vue?vue&type=template&id=c55e24a2&scoped=true"
import script from "./CardAdditionalInformationIcon.vue?vue&type=script&lang=js"
export * from "./CardAdditionalInformationIcon.vue?vue&type=script&lang=js"
import style0 from "./CardAdditionalInformationIcon.vue?vue&type=style&index=0&id=c55e24a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55e24a2",
  null
  
)

export default component.exports